import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "X:/work/newsroom/quiz-silvester/src/templates/default.jsx";
import Quote from '../components/quote/quote.jsx';
import Sharing from '../components/sharing/sharing.jsx';
import { Link, LinkList } from '../components/link/link.jsx';
import { Quiz, Image as QuizImage, Video as QuizVideo, Audio as QuizAudio, Question, Answer, Result, Score as QuizScore } from '../components/quiz/quiz.jsx';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1>{`Silvester-Quiz: Beantworten Sie alle zehn Fragen richtig?`}</h1>
    <h2>{`Traditionelle Bräuche, skurrile Rituale, kultige Gewohnheiten - Jahr für Jahr feiern wir Silvester. Dabei übernehmen wir lieb gewonnene Traditionen und sind damit nicht allein – wie ein Blick über die Landesgrenzen zeigt.`}</h2>
    <p>{`Wie gut kennen Sie sich mit den Silvesterbräuchen aus? Testen Sie ihr Wissen!`}</p>
    <p>{`Viel Spaß beim Durchklicken und Quizzen!`}</p>
    <Quiz mdxType="Quiz">
      <QuizImage src="feuerwerk.png" alt="Feuerwerk" mdxType="QuizImage" />
      <Question mdxType="Question">**Warum heißt Silvester eigentlich Silvester?**</Question>
      <Answer correct mdxType="Answer">Der Tag ist nach einem Papst benannt</Answer>
      <Answer mdxType="Answer">Der Name kommt aus dem Hebräischen und bedeutet „Stilles Fest“</Answer>
      <Answer mdxType="Answer">Silvester war ein altes Glücksspiel im Mittelalter</Answer>
      <Answer mdxType="Answer">Der Tag ist nach einem Fruchtbarkeitsgott benannt</Answer>
      <Result mdxType="Result">
Den Namen Silvester hat das Fest am Jahresende seit dem 16. Jahrhundert, denn 1582 wurde der letzte Tag des Jahres vom heutigen Heiligabend auf den 31. Dezember verlegt, dem Todestag von Papst Silvester.
        <p>{`Mehr dazu: `}<a href="https://www.ardalpha.de/wissen/geschichte/kulturgeschichte/silvester-geschichte-neujahr-jahresanfang-beginn-jahr-jahreswechsel-100.html" target="_blank">{`ARD alpha`}</a></p>
      </Result>
    </Quiz>
    <Quiz mdxType="Quiz">
      <QuizImage src="rutsch.png" alt="Junge rutscht auf Glatteis" mdxType="QuizImage" />
      <Question mdxType="Question">**Was wünschte man sich ursprünglich mit dem Ausdruck „Guten Rutsch!“?**</Question>
      <Answer correct mdxType="Answer">Eine gute Reise</Answer>
      <Answer mdxType="Answer">Einen neuen Schlitten</Answer>
      <Answer mdxType="Answer">Einen Tanzpartner</Answer>
      <Answer mdxType="Answer">Einen baldigen Besuch</Answer>
      <Result mdxType="Result">
Vor über hundert Jahren bedeutete „Rutschen“ auch noch „Reisen“. Mit dem Begriff „Guten Rutsch“ wünschte man sich damals eine gute Reise. Und an Silvester wünschte man sich daraufhin eine gute Reise ins neue Jahr.
        <p>{`Mehr dazu: `}<a href="https://www.wdrmaus.de/filme/sachgeschichten/guter_rutsch.php5" target="_blank">{`Die Maus`}</a></p>
      </Result>
    </Quiz>
    <Quiz mdxType="Quiz">
      <QuizImage src="bulter_james.png" alt="Bulter James mit Tigerfell" mdxType="QuizImage" />
      <Question mdxType="Question">**Die Kultsendung „Dinner for One“ gehört für viele an Silvester zum Pflichtprogramm im Fernsehen. Fan-Frage: Wie oft stolpert Butler James im legendären Sketch über das Tigerfell?**</Question>
      <Answer mdxType="Answer">3 Mal</Answer>
      <Answer mdxType="Answer">8 Mal</Answer>
      <Answer correct mdxType="Answer">11 Mal</Answer>
      <Answer mdxType="Answer">15 Mal</Answer>
      <Result mdxType="Result">
11 Mal stolpert Butler James in dem Sketch über das Tigerfell. Der erste Stolperer des Schauspielers war eher zufällig, brachte ihm aber so viele Lacher, dass das Tigerfell schließlich fester Bestandteil der Aufführung wurde.
        <p>{`Mehr dazu: `}<a href="https://www.rnd.de/medien/dinner-for-one-an-silvester-12-fakten-zum-kult-sketch-YPLV4GMQFNBLFO4LTJUYSDOKCU.html" target="_blank">{`RND`}</a></p>
      </Result>
    </Quiz>
    <Quiz mdxType="Quiz">
      <QuizImage src="weintrauben.png" alt="Weintraubenstand in Spanien" mdxType="QuizImage" />
      <Question mdxType="Question">**In Spanien dreht sich bei der Jahreswende alles um Trauben: Wann bringen sie Glück?**</Question>
      <Answer mdxType="Answer">Wenn man die Kerne einer Traube bis zum nächsten Silvester aufhebt</Answer>
      <Answer mdxType="Answer">Wenn man mit der Traube einen Neujahrsbaum pflanzt</Answer>
      <Answer mdxType="Answer">Wenn man seinen Liebsten eine Traube mit den Lippen übergibt</Answer>
      <Answer correct mdxType="Answer">Wenn man um Mitternacht mit dem jedem Glockenschlag eine Traube isst</Answer>
      <Result mdxType="Result">
Kein Silvester ohne Weintrauben! Bei jedem Glockenschlag wird eine verspeist und man muss sich dabei etwas wünschen. Allerdings müssen die Trauben exakt bis zum letzten Glockenschlag aufgegessen sein, damit das neue Jahr auch wirklich Glück bringt.
      </Result>
    </Quiz>
    <Quiz mdxType="Quiz">
      <QuizImage src="gluecksbringer.png" alt="Glücksbringer in China" mdxType="QuizImage" />
      <Question mdxType="Question">**Mit welchem Brauch hoffen Chinesen im neuen Jahr auf einen Partner?**</Question>
      <Answer mdxType="Answer">Sie werfen eine Flaschenpost ins Wasser</Answer>
      <Answer correct mdxType="Answer">Sie lassen Mandarinen im offenen Meer schwimmen</Answer>
      <Answer mdxType="Answer">Sie vergraben einen Ring aus Blütenstängeln</Answer>
      <Answer mdxType="Answer">Sie kaufen zum Jahreswechsel rote Unterwäsche </Answer>
      <Result mdxType="Result">
Unverheiratete werfen Mandarinen ins Wasser und hoffen, dadurch im neuen Jahr den potenziellen Ehepartner kennenzulernen.
      </Result>
    </Quiz>
    <Quiz mdxType="Quiz">
      <QuizImage src="glueckskatze.png" alt="Glückskatze" mdxType="QuizImage" />
      <Question mdxType="Question">**Was essen Japaner an Silvester als Glücksbringer?**</Question>
      <Answer mdxType="Answer">Den Kopf eines Glücksfisches</Answer>
      <Answer mdxType="Answer">Kalte Buchstabensuppe</Answer>
      <Answer mdxType="Answer">Eine Torte aus Glückskeksen</Answer>
      <Answer correct mdxType="Answer">Klebrige Reisklößchen</Answer>
      <Result mdxType="Result">
Silvester in Japan ist eine klebrige Angelegenheit. Hier verspeist man traditionell das Reisklößchen Mochi, das ein langes Leben und Glück bescheren soll. Ist aber nicht ganz ungefährlich: Immer wieder ersticken Menschen daran, weil es im Hals stecken bleibt. Mittlerweile geben die Behörden Warnungen heraus – man solle Mochi besser in kleinen Stückchen mit viel Wasser verzehren.
      </Result>
    </Quiz>
    <Quiz mdxType="Quiz">
      <QuizImage src="engel.png" alt="Engelstatue vor Feuerwerk auf einem Platz in Prag" mdxType="QuizImage" />
      <Question mdxType="Question">**Von wem oder was lassen sich Tschechen das Schicksal für das Folgejahr vorhersagen?**</Question>
      <Answer mdxType="Answer">Von der Asche einer verbrannten Wurzel</Answer>
      <Answer correct mdxType="Answer">Vom Gehäuse eines halbierten Apfels</Answer>
      <Answer mdxType="Answer">Von fallengelassenen Kieselsteinen</Answer>
      <Answer mdxType="Answer">Von einer frei gelassenen Taube</Answer>
      <Result mdxType="Result">
Tschechen lassen sich ihr Schicksal für das Folgejahr von einem halbierten Apfel voraussagen. Ein sternförmiges Gehäuse steht für Glück, ein Kreuz symbolisiert dagegen Unheil.
      </Result>
    </Quiz>
    <Quiz mdxType="Quiz">
      <QuizImage src="eifel.png" alt="Verschneite Eifel" mdxType="QuizImage" />
      <Question mdxType="Question">**In der Eifel trafen sich früher manche Männer am Jahresende zum…**</Question>
      <Answer correct mdxType="Answer">Brezel-Skat</Answer>
      <Answer mdxType="Answer">Blech-Trommeln</Answer>
      <Answer mdxType="Answer">Nacht-Pfeifen</Answer>
      <Answer mdxType="Answer">Blei-Werfen</Answer>
      <Result mdxType="Result">
Beliebtes Gebäck um die Zeit am Ende des Jahres waren süße Brezeln, die gab es nicht so oft – ein Festgebäck, auch Gebetbrot genannt. In einigen Eifelorten trafen sich Männer zum Jahresende zum Kartenspiel in Kneipen. Der Spieleinsatz: Diese besonderen Brezeln.
        <p>{`Mehr dazu: `}<a href="https://www.ardmediathek.de/video/unterhaltung/boeller-blei-und-brezel-skat/wdr/Y3JpZDovL3dkci5kZS9CZWl0cmFnLWNhYjUxMjU2LWM0OTYtNGE2Yy04N2FkLWYyOWRmYjI2MDA5YQ" target="_blank">{`WDR`}</a></p>
      </Result>
    </Quiz>
    <Quiz mdxType="Quiz">
      <QuizImage src="singen.png" alt="Junger Mann singt mit Kopfhörer" mdxType="QuizImage" />
      <Question mdxType="Question">**Im Sauerland zogen Männer früher zu Neujahr durchs Dorf und sangen. Was bekamen sie dafür?**</Question>
      <Answer mdxType="Answer">Mistelzweige</Answer>
      <Answer mdxType="Answer">Eier und Speck</Answer>
      <Answer mdxType="Answer">Glückspfennige</Answer>
      <Answer correct mdxType="Answer">Würste</Answer>
      <Result mdxType="Result">
Junge Männer zogen früher zum sogenannten Wurstesingen von Haus zu Haus – alles für einen guten Zweck. Es gab neben Würsten auch Geld und Geschenke, die dann versteigert wurden.
        <p>{`Mehr dazu: `}<a href="https://www.facebook.com/heimatflimmern/videos/ungew%C3%B6hnliche-silvesterbr%C3%A4uche-in-nrw/707447900721150/" target="_blank">{`Heimatflimmern (WDR)`}</a></p>
      </Result>
    </Quiz>
    <Quiz mdxType="Quiz">
      <QuizImage src="waffeln.png" alt="Frische Waffeln" mdxType="QuizImage" />
      <Question mdxType="Question">**Wie heißt das traditionelle Neujahrsgebäck in Westfalen-Lippe?**</Question>
      <Answer mdxType="Answer">Nejärken</Answer>
      <Answer mdxType="Answer">Janplätzken</Answer>
      <Answer correct mdxType="Answer">Iserkoken</Answer>
      <Answer mdxType="Answer">Geluecken</Answer>
      <Result mdxType="Result">
Bekannt auch als Neujährchen sind knusprige Waffeln, die im Münsterland oder am Niederrhein unterschiedliche Namen tragen. Iserkoken bezieht sich auf das Eisen, aus dem die Backform besteht – auf Hochdeutsch wird das Gebäck auch Eiserkuchen genannt.
        <p>{`Mehr dazu: `}<a href="https://www.lwl.org/pressemitteilungen/nr_mitteilung.php?urlID=51759" target="_blank">{`LWL`}</a></p>
      </Result>
    </Quiz>
    <QuizScore texts={{
      0: "Quizmaster in Sachen Silvester sind Sie nicht. Aber probieren Sie es doch gleich noch mal. Man wächst an seinen Aufgaben!",
      5: "Nicht schlecht, aber da ist noch Luft nach oben!",
      6: "Wow – verdammt nah dran. Beim nächsten Silvester-Smalltalk können Sie locker mitreden!",
      9: "Fast! Nur noch eine richtige Antwort und Sie wären tatsächlich Silvester-Quizprofi!",
      10: "Glückwunsch! Sie sind ein echter Silvester-Quizprofi!"
    }} mdxType="QuizScore" />
    <Sharing twitter facebook mail whatsapp telegram reddit xing linkedin mdxType="Sharing" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      